const pt = {
  name: 'ptBR',
  months: [
    ['Janeiro', 'Jan'],
    ['Fevereiro', 'Feb'],
    ['Março', 'Mar'],
    ['Abril', 'Abr'],
    ['Maio', 'Mai'],
    ['Junho', 'Jun'],
    ['Julho', 'Jul'],
    ['Agosto', 'Ago'],
    ['Setembro', 'Set'],
    ['Outubro', 'Out'],
    ['Novembro', 'Nov'],
    ['Dezembro', 'Dez'],
  ],
  weekDays: [
    ['Sábado', 'sab'],
    ['Domingo', 'dom'],
    ['Segunda-feira', 'seg'],
    ['Terça-feira', 'ter'],
    ['Quarta-feira', 'qua'],
    ['Quinta-feira', 'qui'],
    ['Sexta-feira', 'sex'],
  ],
  digits: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
  meridiems: [
    ['AM', 'am'],
    ['PM', 'pm'],
  ],
};

export default pt;
